module.exports = __webpack_public_path__ + "img/pic_antivirus@2x.ede5ec85.png";